import React, { lazy, Suspense, useCallback, useState } from "react";
import { SubHeading } from "../../shared/Components";
import CommonModal from "../../shared/Components/Modal/CommonModal";
import Confirmation from "../../shared/Components/UI/Confirmation";
import CheckPasswordModal from "../../shared/Components/Modal/CheckPasswordModal";

const OpenMarketBody = lazy(() => import("./OpenMarketBody"));
const OpenMarket = () => {
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
    handleCancel: null,
    handleDelete: null,
  });

  // const handleConfirmModal = useCallback((rowData) => {
  //   setIsShow({
  //     rowData,
  //     isOpen: true,
  //     modalContent: Confirmation,
  //     modalTitle: "Settlement",
  //     modalSize: "md",
  //   });
  // });

  // const handleCancleModal = useCallback((rowData) => {
  //   setIsShow({
  //     rowData,
  //     isOpen: true,
  //     modalContent: CheckPasswordModal,
  //     modalTitle: `Cancel Market (${rowData.marketType})`,
  //     modalSize: "md",
  //     isConfirmed : true,
  //   });
  // });

  return (
    <>
      <SubHeading isAddBtn={false} />

      <Suspense fallback={<div>Loading...</div>}>
        <OpenMarketBody
          // onConfirmModal={handleConfirmModal}
          // onCancleModal={handleCancleModal}
          handleModal={setIsShow}
        />
      </Suspense>
      {isShow.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          size="md"
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleShowHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  modalTitle: "",
                })),
              rowData: isShow.rowData,
              // isConfirmed: isShow.isConfirmed,
              handleCancel: isShow.handleCancel,
              handleDelete: isShow.handleDelete,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default OpenMarket;
